import React, { useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { trans } from '../../../../_providers/Translation';

function Index(props) {

    const handleTab = (e, tab) => {
        props.handleTab(tab);
    }

    return (
        <Tabs
            value={props.tab}
            onChange={handleTab}
            variant="scrollable"
            scrollButtons="auto"
            indicatorColor="primary"
            textColor="primary"
            aria-label="scrollable force tabs"
        >
            <Tab value="list" label={trans('tabs.list')} disableRipple={true} />
            <Tab value="stats" label={trans('tabs.stats')} disableRipple={true} />
        </Tabs>
    )
}

export default Index;